import { Container } from "./style";
import Moment from 'react-moment';
import { IconStatus } from "../../icons";
import { getActionText } from "../../../utility/actionTextMapper";

// Responsável type mapping
const RESPONSAVEL_TYPE_MAP: Record<string, string> = {
    'Operador': 'P',
    'Profissional': 'D',
    'Admin': 'J',
    'Solicitante': 'ES',
    'Sistema': 'prazo de aceite excedido',
};

export function TimelineProposta({ historyProposal }: any) {

    const getResponsavelText = (tipo: string, id: string): string => {
        const prefix = RESPONSAVEL_TYPE_MAP[tipo];
        return prefix && prefix !== 'prazo de aceite excedido' ? `${prefix}${id}` : prefix || '';
    };

    return (
        <Container>
        {
            historyProposal?.length > 0 &&
            historyProposal.map((row: any) => (
                <div className="line-info" key={row.id_historico_proposta}>
                    <div className="date">
                        <Moment locale='pt-br' format="DD/MM/YY">{row.criado}</Moment>
                    </div>
                    <div
                        className={
                            row.acao === 'criou proposta' ? 'bullet start' :
                            row.acao === 'cancelou' || row.acao.includes('Excedeu') ? "bullet end" : 'bullet'
                        }
                    >
                        <IconStatus />
                    </div>
                    <div className="event">
                        {getActionText(row.acao)} por {row.nome_responsavel.split(' ')[0]} {getResponsavelText(row.tipo_responsavel, row.id_responsavel)}
                    </div>
                </div>
            )).reverse()
        }
        </Container>
    )
}